import { isRecord } from '@/types/componentDataBinding';

export interface DataBindingWriteTargetState {
  writeTarget: unknown;
  requireExplicitWriteTarget: boolean;
}

export function getDataBindingWriteTarget(
  dataBinding: unknown,
): DataBindingWriteTargetState {
  if (dataBinding === undefined) {
    return {
      writeTarget: undefined,
      requireExplicitWriteTarget: false,
    };
  }

  if (!isRecord(dataBinding)) {
    return {
      writeTarget: undefined,
      requireExplicitWriteTarget: true,
    };
  }

  return {
    writeTarget: Object.prototype.hasOwnProperty.call(dataBinding, 'writeTarget')
      ? dataBinding.writeTarget
      : undefined,
    requireExplicitWriteTarget: true,
  };
}
